import { Table } from 'antd';
import styled from 'styled-components';
import upIcon from '@/images/common/dir/hollow-bottom.svg';
import downIcon from '@/images/common/dir/hollow-top.svg';

export const CustomTable = styled(Table)<{ isShowBorder?: boolean }>`
	border: ${({ isShowBorder }) => (isShowBorder ? '1px solid #DFE1E6' : 'none')};
	height: 100%;
	/* padding: 0 12px; */
	.ant-table {
		color: #172b4d;
	}
	& .ant-table-thead {
		& .ant-table-cell {
			text-align: left;
			background: #fff;
			border-bottom: 1px solid rgba(223, 225, 230, 1);
			border-left: none;
			color: #0052cc;
			padding: 0 16px;
			height: 48px;
			line-height: 48px;
		}

		> tr
			> th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
			position: absolute;
			right: 0;
			width: 0;
			height: 55px;
		}
	}

	& .ant-table-tbody > tr > td {
		padding: 0 16px;
		height: 55px;
	}
	& .ant-table-column-sorter-inner {
		.ant-table-column-sorter-up,
		.ant-table-column-sorter-down {
			background-image: url(${upIcon});
			background-repeat: no-repeat;
			height: 15px;
			width: 15px;
			background-position: center center;
			display: none;
			> svg {
				display: none;
			}
			&.active {
				display: block;
			}
		}
		.ant-table-column-sorter-down {
			background-position: center 5px;
			background-image: url(${downIcon});
		}
	}

	& .ant-skeleton-element .ant-skeleton-button {
		height: 24px;
	}
	.ant-table-thead > tr > th {
		font-weight: normal;
	}
`;
